import type { EntityQuery } from '~/types/OpenSearch';

import { pilotV3 } from '~/services/serviceInstances';

/*
 * Flat request and response — no JSON:API `data.attributes` wrapper on either
 * side. Every other `pilotV3` method in this directory wraps; this one does
 * not, because POST /home/work/ is not a JSON:API resource.
 */
export type HomeWorkLane = 'overdue' | 'this_week' | 'coming_up';

export interface HomeWorkRequest {
  lane: HomeWorkLane;
  include_renewals: boolean;
  include_auto_renewals: boolean;
  include_requests?: boolean;
  renewal_lead_days?: number;
  auto_renewal_lead_days?: number;
  request_due_default_days?: number;
  overdue_max_age_days?: number | null;
  scope_query?: EntityQuery[];
}

export interface HomeWorkHandler {
  id: number;
  name: string;
  file_type: string;
  folder_id: number;
}

export interface HomeWorkDocumentItem {
  /** Absent until Pilot ships pilot#3967 (Your Work Stage 3). */
  kind?: 'document';
  document_id: number;
  document_handlers: HomeWorkHandler[];
  work_type: 'renewal' | 'auto_renewal';
  action_date: string;
  counterparties: string[];
  contract_type: string | null;
}

/** A request row in the Home work response. */
export interface HomeWorkRequestItem {
  kind: 'request';
  ticket_id: string;
  name: string;
  state: string;
  current_stage_name: string;
  action_date: string;
  counterparties: string[];
  contract_type: string | null;
}

export type HomeWorkItem = HomeWorkDocumentItem | HomeWorkRequestItem;

export type HomeWorkSourceStatus = 'ok' | 'error' | 'off';

export interface HomeWorkSources {
  documents: HomeWorkSourceStatus;
  requests: HomeWorkSourceStatus;
}

export interface HomeWorkResponse {
  items: HomeWorkItem[];
  /** `document_total + request_total`. */
  total: number;
  /** Absent until Pilot ships pilot#4249 (per-source lane totals). */
  document_total?: number;
  /** Absent until Pilot ships pilot#4249 (per-source lane totals). */
  request_total?: number;
  /** Absent until Pilot ships pilot#3967 (Your Work Stage 3). */
  sources?: HomeWorkSources;
}

export const postHomeWork = (
  body: HomeWorkRequest,
  signal?: AbortSignal,
): Promise<HomeWorkResponse> => pilotV3.post('/home/work/', body, { signal });
